/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Types of validation documents.
 */
export var ExternalValidationDocumentType;

(function (ExternalValidationDocumentType) {
  ExternalValidationDocumentType["UNSPECIFIED"] = "unspecified";
  ExternalValidationDocumentType["SCHEDULE"] = "schedule";
  ExternalValidationDocumentType["CERTIFICATE"] = "certificate";
})(ExternalValidationDocumentType || (ExternalValidationDocumentType = {}));